import React, { useState } from "react";
import TextField from "../../../UI/TextField";
import InputButton from "../../../UI/InputButton";
import {questionnaire59, questionnaire60 } from "../../../../Constants/Questions"; 

//import RadioButtonQuest from "../../../UI/RadioButtonQuest";
const QuestionnaireAgreementNoModal = ({
  validation,
  validationMsg,
  trigger, 
  agNoShow,
  saveInputAns,
  skipAgNo
}) => {
  // console.log("monthlyExpShow:-"+monthlyExpShow);
  // console.log("showModel1:-"+showModel1);
  // console.log("showModel2:-"+showModel2);

//   const questionId = questArr.questionId ? questArr.questionId : 0; 

        const agreementValidation = async (e) => {
            let agreement_no = await trigger("question_45");
            if (agreement_no) {
            saveInputAns(e);
            // setAgNoShow('hide');
            } else {
            return false;
            }
        };
        
        const skip_agree_no = async (e) => {
            // setAgNoShow('hide');
            skipAgNo(e);
            // setSkipAgNo(true);
        };

  return (
    <>
      <div role="dialog" className={`fade modal blackover ${agNoShow}`}>
          <div className="modal-dialog modal-md modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <h3 className="text-center fonts15">Enter your Credit Agreement Number</h3>
                <div className="input-group mb-3 justify-content-center">
                  <div className="mb-3 mt-3 col-12 p-0">
                    <div className="input-group mb-3">
                      <TextField
                        type="tel"
                        className="form-control"
                        placeholder="Credit Agreement Number"
                        // name="question_51"
                        name="question_45"
                        validation={validation({
                          required: "Please Enter Agreement Number",
                          minLength: {
                            value: 3,
                            message: "Please Enter Valid Agreement Number",
                          },
                          pattern: {
                            value: /^\d*[1-9]\d*$/,
                            message:
                              "Agreement Number is Invalid. Please Recheck",
                          },
                        })}
                        validationMsg={
                          validationMsg.question_45 &&
                          validationMsg.question_45.message
                        }
                      ></TextField>
                    </div>

                    <InputButton
                      name="agreement_no"
                      className="btn-next regNextBtn"
                      id=""
                      value="Next"
                      btnType="button"
                      onClick={agreementValidation}
                      style={{ float: "none" }}
                      dataQuestId = "45"
                    />
                    <p className="text-center">
                    <InputButton
                      name="skip_agree_no"
                      className="btn btn-link"
                      id=""
                      value="SKIP for now and follow up ASAP"
                      btnType="button"
                      onClick={skip_agree_no}
                      style={{ float: "none" }}
                    />
                    </p>

                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
    </>
  );
};

export default QuestionnaireAgreementNoModal;